import React from "react";
import { FixedSizeGrid } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import ProposalCard from "../ProposalCard";

export default function ProposalVirtualList({
                                                items,
                                                onPreview,
                                                onDelete,
                                                containerHeight = 800,

                                                // approximate card size (without gap)
                                                cardWidth = 280,
                                                cardHeight = 500,

                                                // gap between columns/rows
                                                gapX = 24,
                                                gapY = 50,
                                            }) {
    // 1) Decide column count by width
    function getColumnCount(width) {
        if (width < 640) return 1;       // 'sm:' tailwind breakpoint
        else if (width < 1024) return 2; // 'md:' or 'lg:'
        else return 3;                   // >= 'lg:'
    }

    // 2) Our cell renderer
    const Cell = ({ columnIndex, rowIndex, style, data }) => {
        const { items, colCount, rowCount, onPreview, onDelete, gapX, gapY } = data;
        const itemIndex = rowIndex * colCount + columnIndex;
        if (itemIndex >= items.length) return null;

        const item = items[itemIndex];

        // "마지막 열/행"이면 오른쪽/아래쪽 margin을 0으로 처리
        const isLastCol = (columnIndex === colCount - 1);
        const isLastRow = (rowIndex === rowCount - 1);

        return (
            <div style={style}>
                {/* Nested div to apply some "padding" = half the gap on each side */}
                <div
                    style={{
                        // width: "100%",
                        // height: "100%",
                        margin: gapX,
                        marginBottom: gapY
                    }}
                >
                    <ProposalCard
                        item={item}
                        pageNumber={item.pageNumber} // if needed
                        onPreview={onPreview}
                        onDelete={onDelete}
                    />
                </div>
            </div>
        );
    };

    return (
        // A parent container with fixed height
        <div className="mx-auto w-full" style={{ height: containerHeight }}>
            <AutoSizer disableHeight>
                {({ width }) => {
                    // 3) Figure out columns
                    const colCount = getColumnCount(width);

                    // 4) Calculate each column’s width so we have gapX between columns
                    // total horizontal gap = gapX * (colCount - 1)
                    // so actual card area = (width - totalGap) / colCount
                    // then we add gapX back in for the cell’s allocated space
                    const totalGapX = gapX * (colCount - 1);
                    const actualCardWidth = (width - totalGapX) / colCount;

                    // if you want the card’s width to be around 280, you can clamp or adjust:
                    // but typically we just distribute space equally
                    const columnWidth = actualCardWidth + 0; // no extra gap here if we handle it in the padding

                    // 5) rowHeight must be fixed with FixedSizeGrid
                    // cardHeight + gap
                    const rowHeight = cardHeight + gapY;

                    // 6) total # of rows
                    const rowCount = Math.ceil(items.length / colCount);

                    return (
                        <FixedSizeGrid
                            columnCount={colCount}
                            columnWidth={columnWidth}
                            rowCount={rowCount}
                            rowHeight={rowHeight}
                            width={width}
                            height={containerHeight}
                            itemData={{
                                items,
                                colCount,
                                rowCount,
                                onPreview,
                                onDelete,
                                gapX,
                                gapY,
                            }}
                        >
                            {Cell}
                        </FixedSizeGrid>
                    );
                }}
            </AutoSizer>
        </div>
    );
}